export class User {

    accountType = '';
    accountName = '';
    status = '';
    uid = '';
    pinLevel = '';
    legalEntityType = '';
    userId = '';

    constructor(account = null) {
        if (account) {
            this.accountType = account.accountType || this.accountType;
            this.accountName = account.name || this.accountName;
            this.status = account.status || this.status;
            this.uid = account.uid || this.uid;
            this.pinLevel = account.pinLevel || this.pinLevel;
            this.legalEntityType = account.legalEntityType || this.legalEntityType;
            this.userId = (account.primaryParty && account.primaryParty.uid) ? account.primaryParty.uid : this.userId;
        }
    }
}
